import React, { useRef, useState } from "react";
import axios from "axios";
import "./Translate.css";
import { marked } from "marked";
import TurndownService from "turndown";
import htmlDocx from "html-docx-js/dist/html-docx";
import PopupWindow from "./PopupWindow";

const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;

const Translate = () => {
  const tagUrlMap = {
    buildingyourwebsite: "/blog/building-your-site",
    buildingyoursite: "/blog/building-your-site",
    buildyoursite: "/blog/building-your-site",
    entrepreneurship: "/blog/entrepreneurship",
    promotingyoursite: "/blog/promoting-your-site",
    promoteyoursite: "/blog/promoting-your-site",
    designandinspiration: "/blog/design-and-inspiration",
    designinspiration: "/blog/design-and-inspiration",
    tipsandtricks: "/blog/tips-and-tricks",
  };

  const BASEURL = {
    GET_MARKDOWN: `${apiEndpoint}/api/get-markdown`,
    TRANSLATE_MARKDOWN: `${apiEndpoint}/api/translate-markdown`,
    GENERATE_XML: `${apiEndpoint}/api/generate-xml`,
    GET_PROMPT: `${apiEndpoint}/api/get-live-prompt`,
    CHECK_JOB_STATUS: `${apiEndpoint}/api/check-job-status`,
  };
  // const BASEURL = {
  //   GET_MARKDOWN: "http://localhost:8000/api/get-markdown",
  //   TRANSLATE_MARKDOWN: "http://localhost:8000/api/translate-markdown",
  //   GENERATE_XML: "http://localhost:8000/api/generate-xml",
  //   GET_PROMPT: "http://localhost:8000/api/get-live-prompt",
  //   CHECK_JOB_STATUS: "http://localhost:8000/api/check-job-status",
  // };
  const [url, setUrl] = useState("");
  const [glossary, setGlossary] = useState("Glossary 1");
  const [updateGlossary, setUpdateGlossary] = useState("Glossary 1-2024/5/23");
  const [originalText, setOriginalText] = useState("");
  const [translatedText, setTranslatedText] = useState("");
  const [markdown, setMarkdown] = useState("");
  const [Language, setLanguage] = useState("Simplified Chinese");
  const [loading, setLoading] = useState(false); //Add loading effect.
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [BlogPromptText, setBlogPromptText] = useState("");
  const [KbPromptText, setKbPromptText] = useState("");
  const [ReviewPrompt, setReviewPromptText] = useState("");

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  const handleSave = (newText1, newText2,newText3) => {
    setBlogPromptText(newText1);
    setKbPromptText(newText2);
    setReviewPromptText(newText3);
    // console.log(BlogPromptText);
    // console.log(KbPromptText);
  };
  const handlePreview = async () => {
    try {
      try {
        if (!url) {
          throw new Error("URL cannot be empty. Please provide a URL.");
        }
      } catch (error) {
        console.error("Error fetching markdown:", error);
        alert(`Error: ${error.message}`);
      }
      const response = await axios.get(`${BASEURL.GET_MARKDOWN}?url=${url}`, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      console.log(response);

      try {
        if (response.data.includes("Unknown URL type")) {
          throw new Error(`Unknown URL type (${url})`);
        }

        const turndownService = new TurndownService();

        const extractTextFromNode = (node) => {
          let result = "";
          const processNode = (currentNode) => {
            currentNode.childNodes.forEach((child) => {
              if (child.nodeType === Node.TEXT_NODE) {
                result += child.textContent;
              } else if (child.nodeName === "STRONG") {
                // result += `**${child.textContent}**`;
                result += child.textContent;
              } else if (child.nodeName === "A") {
                const href = child.getAttribute("href");
                const text = child.textContent;
                result += `[${text}](${href})`;
              } else if (child.nodeName === "SPAN") {
                processNode(child);
              } else if (child.nodeName === "P") {
                processNode(child);
              }
            });
          };
          processNode(node);
          return result.trim();
        };
        turndownService.addRule("customH1", {
          filter: "h1",
          replacement: function (content, node) {
            let textContent = node.querySelector("strong")
              ? node.querySelector("strong").textContent
              : content;
            textContent = textContent.trim();
            return `# **${textContent}**\n\n`;
          },
        });

        turndownService.addRule("customH2", {
          filter: "h2",
          replacement: function (content, node) {
            const result = extractTextFromNode(node);
            return result ? `## **${result}**\n\n` : "";
          },
        });

        turndownService.addRule("customH3", {
          filter: "h3",
          replacement: function (content, node) {
            const result = extractTextFromNode(node);
            return result ? `### ${result}\n\n` : "";
          },
        });

        turndownService.addRule("customH4", {
          filter: "h4",
          replacement: function (content, node) {
            const result = extractTextFromNode(node);
            return result ? `#### ${result}\n\n` : "";
          },
        });

        turndownService.addRule("imageWithLink", {
          filter: function (node) {
            return node.nodeName === "A" && node.querySelector("img") !== null;
          },
          replacement: function (content, node) {
            const img = node.querySelector("img");
            const src = img.getAttribute("src");
            const alt = img.getAttribute("alt") || "";
            const title = img.getAttribute("title") || "";
            const link = node.getAttribute("href");
            const titlePart = title ? ` "${title}"` : "";
            return `[![${alt}](${src}${titlePart})](${link})`;
          },
        });
        turndownService.addRule("imageWithDataSrc", {
          filter: "img",
          replacement: function (content, node, options) {
            const dataSrc = node.getAttribute("data-src");
            const src = node.getAttribute("src");
            const alt = node.alt || "";
            const url = dataSrc || src; // For images, src defaults to low-quality image and data-src to high-quality image; if data-src is present, parse data-src
            return url ? `![${alt}](${url})` : "";
          },
        });
        turndownService.addRule("spanWithBlogTags", {
          filter: function (node) {
            return (
              node.nodeName === "SPAN" && node.classList.contains("s-blog-tags")
            );
          },
          replacement: function (content, node) {
            let result = "";
            node.childNodes.forEach((child) => {
              if (
                child.nodeName === "SPAN" &&
                child.classList.contains("s-blog-tag")
              ) {
                let text = child.textContent.trim().replace(/,$/, ""); // Remove trailing comma
                let key = text.replace(/\s+/g, "").toLowerCase(); // Convert key to lowercase and remove spaces
                let href = tagUrlMap[key] || "#"; // Default to '#' if no match
                let classAttr = child.getAttribute("class");
                result += `<span class="${classAttr}"><a href="${href}">${text}</a></span>, `;
              }
            });
            return result.replace(/,\s*$/, ""); // Remove trailing comma and space
          },
        });
        turndownService.addRule("customLink", {
          filter: "a",
          replacement: function (content, node) {
            if (!content.trim()) {
              return "";
            }
            const href = node.getAttribute("href");
            return `[${content.trim()}](${href})`;
          },
        });
        // Add a custom rule for converting breadcrumbs
        turndownService.addRule("breadcrumbs", {
          filter: function (node) {
            // Check if the node is an ordered list with a class indicating it's a breadcrumb
            return (
              node.nodeName === "OL" && node.classList.contains("breadcrumbs")
            );
          },
          replacement: function (content, node) {
            // Extract each link and its text from the breadcrumb list
            const links = [];
            node.querySelectorAll("li a").forEach((a) => {
              const url = a.getAttribute("href");
              const text = a.textContent.trim();
              links.push(`[${text}](${url})`);
            });

            return links.join(" > ");
          },
        });
        // Adding a rule to handle strong tags properly
        turndownService.addRule("strong", {
          filter: ["strong", "b"],
          replacement: function (content) {
            return content.trim() ? `**${content.trim()}**` : "";
          },
        });

        // Function to clean unnecessary breaks and spaces
        function cleanMarkdown(html) {
          // Replace consecutive <br/> tags with a single one
          html = html.replace(/(<br\/>\s*)+/g, "<br/>");
          // Remove non-breaking spaces where not needed
          html = html.replace(/ /g, " ");
          // Remove empty paragraphs
          html = html.replace(/<p>\s*<\/p>/g, "");
          html = html.replace(/\*{4}/g, "");
          return html;
        }
        const parser = new DOMParser();
        const doc = parser.parseFromString(response.data, "text/html");
        doc.querySelectorAll("h3").forEach((h3) => {
          if (h3.querySelector("em")) {
            h3.remove();
          }
        });

        let markdownData = turndownService.turndown(response.data);
        setMarkdown(markdownData);
        markdownData = cleanMarkdown(markdownData);
        console.log(markdownData);
        setOriginalText(marked.parse(markdownData));
      } catch (error) {
        alert(
          `Error: The URL cannot be properly requested. Please check if the URL is a supported address.`
        );
      }
    } catch (error) {
      console.error("Error fetching markdown:", error);
    }
  };
  const pollJobStatus = (jobId) => {
    const intervalId = setInterval(async () => {
      try {
        const response = await axios.get(
          `${BASEURL.CHECK_JOB_STATUS}/${jobId}`
        );

        if (response.status !== 200) {
          throw new Error("Network response was not ok");
        }

        const jobStatus = response.data.status;

        if (jobStatus === "completed") {
          if (response.data.result.status_code !== 200) {
            console.log(response.data.result.message);
            throw new Error(response.data.result.message);
          }
          clearInterval(intervalId);
          setTranslatedText(marked(response.data.result.data));
          setLoading(false);
          console.log("Translation completed:", response.data.result);
        } else if (jobStatus === "failed") {
          clearInterval(intervalId);
          setLoading(false);
          throw new Error(response.data.message || "Translation job failed");
        }
      } catch (error) {
        clearInterval(intervalId);
        console.error("Error polling job status:", error);
        alert(`Error polling job status: ${error.message}`);
        setLoading(false);
      }
    }, 10000); // 每10秒轮询一次
  };

  const handleTranslate = async () => {
    setLoading(true);
    console.log("Sending request: ",{
          markdown: markdown,
          glossary: glossary,
          Language: Language,
          PromptText: BlogPromptText,
          KbPromptText: KbPromptText,
          reviewPromptText: ReviewPrompt,
          url: url,
        },);
    try {
      if (!markdown) {
        throw new Error(
          "No data retrieved. Please use Preview button retrieve the data first."
        );
      }
      console.log(ReviewPrompt)
      const response = await axios.post(
        BASEURL.TRANSLATE_MARKDOWN,
        {
          markdown: markdown,
          glossary: glossary,
          Language: Language,
          PromptText: BlogPromptText,
          KbPromptText: KbPromptText,
          reviewPromptText: ReviewPrompt,
          url: url,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      pollJobStatus(response.data.job_id);
      if (response.status !== 202) {
        console.log(response);
        throw new Error("Network response was not ok");
      }
    } catch (error) {
      console.error("Error translating markdown:", error);
      alert(`Error: ${error.message}`);
    }
  };

  const convertTranslationToXML = async (translatedText) => {
    try {
      const response = await axios.post(
        BASEURL.GENERATE_XML,
        {
          HTML: translatedText,
          url: url,
          Language: Language,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status !== 200) {
        throw new Error("Network response was not ok");
      }

      const xmlContent = response.data;
      console.log(xmlContent);
      // Convert XML content to Blob
      const xmlBlob = new Blob([xmlContent], { type: "application/xml" });

      return xmlBlob;
    } catch (error) {
      console.error("Error generating XML:", error);
      throw new Error(`Error: ${error.message}`);
    }
  };

  const handleDownload = async () => {
    try {
      const xmlBlob = await convertTranslationToXML(translatedText);

      // Create a link element to download the XML file
      const url = URL.createObjectURL(xmlBlob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "translated_content.xml";
      document.body.appendChild(a);
      a.click();

      // Clean up
      URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error downloading XML:", error);
    }
  };

  const textBoxRef = useRef(null);

  const copyToClipboard = async () => {
    const textBox = textBoxRef.current;
    const htmlContent = textBox.outerHTML;

    // 创建一个虚拟的HTML文档以便于复制
    const blob = new Blob([htmlContent], { type: "text/html" });
    const clipboardItem = new ClipboardItem({ "text/html": blob });

    try {
      await navigator.clipboard.write([clipboardItem]);
      alert("Copied to clipboard!");
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  const handleLanguage = (event) => {
    setLanguage(event.target.value);
    console.log(Language);
  };

  const handleGlossaryChange = (event) => {
    setGlossary(event.target.value);
  };

  const handleUpdateGlossary = () => {
    // 在这里添加更新glossary逻辑
    console.log("Update Glossary clicked");
  };

  const getLivePrompt = async () => {
    console.log("Get Live Prompt");
    const response = await axios.get(
      `${BASEURL.GET_PROMPT}?url=${url}&language=${Language}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status !== 200) {
      alert("Network response was not ok"); // Show error in a popup
      throw new Error("Network response was not ok");
    }

    // Displaying the response data in a popup
    alert(`Response received: ${JSON.stringify(response.data)}`);
    console.log(response);
  };

  return (
    <div className="Translate">
      <header className="Translate-header"></header>
      <div className="Urls">
        <input
          type="text"
          placeholder="input URL"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          className="url-input"
        />
        <button onClick={handlePreview}>Preview</button>

        <button
          onClick={handleTranslate}
          disabled={loading}
          className={loading ? "loading-button" : ""}
        >
          {loading ? "Translating..." : "Translate"}
        </button>
        <button onClick={openPopup}>Edit Prompt</button>
        <PopupWindow
          isOpen={isPopupOpen}
          onClose={closePopup}
          onSave={handleSave}
          initialContent1={BlogPromptText}
          initialContent2={KbPromptText}
          initialContent3={ReviewPrompt}
          url={`${BASEURL.GET_PROMPT}?language=${Language}`}
        />
      </div>

      <div className="controls">
        <div className="control-group">
          <h3>Select Language</h3>
          <select value={Language} onChange={handleLanguage}>
            <option value="Simplified Chinese">Simplified Chinese</option>
            <option value="Japanese">Japanese</option>
            <option value="Traditional Chinese">Traditional Chinese</option>
            <option value="Arabic">Arabic</option>
            <option value="Czech">Czech</option>
            <option value="German">German</option>
            <option value="Spanish">Spanish</option>
            <option value="Finnish">Finnish</option>
            <option value="French">French</option>
            <option value="Indonesian">Indonesian</option>
            <option value="Italian">Italian</option>
            <option value="Dutch">Dutch</option>
            <option value="Norwegian">Norwegian</option>
            <option value="Polish">Polish</option>
            <option value="Portuguese">Portuguese</option>
            <option value="Romanian">Romanian</option>
            <option value="Slovak">Slovak</option>
            <option value="Swedish">Swedish</option>
            <option value="Vietnamese">Vietnamese</option>
            <option value="Korean">Korean</option>
            <option value="Russian">Russian</option>
          </select>
        </div>
        <div className="control-group">
          <h3>Select Glossary</h3>
          <select value={glossary} onChange={handleGlossaryChange}>
            <option value="Glossary 1">Glossary 1</option>
            <option value="Glossary 2">Glossary 2</option>
            <option value="Glossary 3">Glossary 3</option>
          </select>
          <button onClick={handleUpdateGlossary}>Update</button>
        </div>

        <div className="control-group">
          {/* <h3>Get Live Prompt</h3> */}
          <h3>Update Glossary</h3>
          <select
            value={updateGlossary}
            onChange={(e) => setUpdateGlossary(e.target.value)}
          >
            <option value="Glossary 1-2024/5/23">Glossary 1-2024/5/23</option>
            <option value="Glossary 2-2024/5/23">Glossary 2-2024/5/23</option>
            <option value="Glossary 3-2024/5/23">Glossary 3-2024/5/23</option>
          </select>
          <button onClick={handleUpdateGlossary}>Update</button>
          {/* <button onClick={getLivePrompt}> Get Live Prompt </button> */}
        </div>
        <div className="control-group">
          <h3>Export</h3>
          <button onClick={copyToClipboard}>Copy Translation</button>
          <button onClick={handleDownload}> Export .XML </button>
        </div>
      </div>
      <div className="text-display">
        <div className="text-section">
          <h3>Original</h3>
          <div
            className="text-box"
            dangerouslySetInnerHTML={{ __html: originalText }}
          ></div>
        </div>
        <div className="text-section">
          <h3>Translation</h3>
          <div
            className="text-box"
            ref={textBoxRef}
            id="Translation"
            dangerouslySetInnerHTML={{ __html: translatedText }}
          ></div>
        </div>
      </div>
      <header className="Translate-header">
        Version: {process.env.REACT_APP_COMMIT_SHA}
      </header>
    </div>
  );
};

export default Translate;
